import { App } from "vue";
import OktaAuth from "@okta/okta-auth-js";
import OktaVue from "@okta/okta-vue";
import { SSOConfig } from "@telegraphio/bapi-types";

export function createOktaApp(app: App, config: SSOConfig) {
  const oktaAuth = new OktaAuth({
    issuer: config.auth.issuer,
    clientId: config.auth.client_id,
    redirectUri: config.auth.redirect_uri ?? "",
    scopes: config.auth.scopes,
  });
  app.use(OktaVue, { oktaAuth });
}

/**
 * Clears Okta token storage from localStorage if it exists
 * @returns True if Okta token was cleared, false otherwise
 */
export function clearOktaTokenStorage(): boolean {
  const oktaTokenStorage = localStorage.getItem("okta-token-storage");
  if (oktaTokenStorage && Object.keys(JSON.parse(oktaTokenStorage)).length) {
    localStorage.removeItem("okta-token-storage");
    return true;
  }
  return false;
}
